import React from "react";

export default function ActionButton(props) {
  return (
    <button
      onClick={props.onClick}
      className={`button action${props.negative ? " negative" : ""}${
        props.cls ? ` ${props.cls}` : ""
      }`}
      style={props.style}
      disabled={props.disabled}
    >
      {props.text}
    </button>
  );
}

ActionButton.defaultProps = {
  cls: "",
  disabled: false,
  loading: false,
  negative: false,
  style: {},
  text: "Basic",
};
